import styled from '@emotion/styled';
import { IconButton } from 'UI';

export const Container = styled(IconButton)`
  margin-top: auto;
  align-self: center;
  cursor: pointer;
`;
